<div class="subscription-modal" ngbAutofocus>
  <img
    class="subscription-modal_image"
    [src]="creatorData?.thumbnail_image || creatorData?.image"
    [alt]="creatorData?.creator_name || creatorData?.name"
  />
  <stxt-svg-icon
    class="subscription-modal_svg"
    [iconConfig]="closeSvg"
    (click)="activeModal.close()"
    (keydown.enter)="activeModal.close()"
  ></stxt-svg-icon>
  <div class="subscription-modal_content">
    <p class="subscription-modal_heading">Want to do more with me?</p>
    <p class="subscription-modal_subheading">
      Subscribe to {{ creatorData?.creator_name || creatorData?.name }} for just
      {{ subscriptionPrice / 100 | currency }}/month.
    </p>
    <div class="subscription-modal_benefits flex">
      <div class="subscription-modal_benefit flex">
        <stxt-svg-icon
          class="subscription-modal_benefit-svg"
          [iconConfig]="chatSvg"
        ></stxt-svg-icon>
        <p>
          Unlimited chat
          <span>private & judgement free</span>
        </p>
      </div>
      <div class="subscription-modal_benefit flex">
        <stxt-svg-icon
          class="subscription-modal_benefit-svg"
          [iconConfig]="giftSvg"
        ></stxt-svg-icon>
        <p>
          Custom images
          <span>made fast, NSFW to X-rated</span>
        </p>
      </div>
      <div *ngIf="isVoiceCallEnabled" class="subscription-modal_benefit flex">
        <stxt-svg-icon
          class="subscription-modal_benefit-svg"
          [iconConfig]="lipsSvg"
        ></stxt-svg-icon>
        <p>
          Sexy voice calls
          <span>ready to whisper in your ear</span>
        </p>
      </div>
      <div class="subscription-modal_benefit flex">
        <stxt-svg-icon
          class="subscription-modal_benefit-svg"
          [iconConfig]="heartSvg"
        ></stxt-svg-icon>
        <p>
          Fine-tune creations
          <span>regenerate as you please</span>
        </p>
      </div>
      <div class="subscription-modal_benefit flex">
        <stxt-svg-icon
          class="subscription-modal_benefit-svg"
          [iconConfig]="crownSvg"
        ></stxt-svg-icon>
        <p>
          VIP {{ creatorData?.creator_name || creatorData?.name }} content
          <span>available only through AI</span>
        </p>
      </div>
    </div>
    <stxt-button
      class="subscription-modal_btn"
      [buttonConfig]="subscribeBtn"
      (click)="openPaymentEvent()"
      (keydown.enter)="openPaymentEvent()"
    >
      {{ subscribeBtn.text }}
    </stxt-button>
    <p class="subscription-modal_footer-text">24/7 access • Risk free • Cancel anytime.</p>
  </div>
</div>
